
import StudentProfileModel from './StudentProfileModel';
import S3PhotoModel from './S3PhotoModel';
import LocationModel from './LocationModel';

export default class UserModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;

    this.city = data.city ? new LocationModel(data.city) : null;

    this.phone_number = data.phone_number || '';
    this.allow_sms_notifications = data.allow_sms_notifications || false;

    this.photo = data.photo ? new S3PhotoModel(data.photo) : null;

    this._unread_messages_count = data._unread_messages_count || 0;
    this._unread_notifications_count = data._unread_notifications_count || 0;

    this.is_counselor = data.is_counselor || false;
    this.is_student = data.is_student || false;
    this.is_college_admin = data.is_college_admin || false;
    this.is_super_admin = data.is_super_admin || false;

    // register
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';

    // welcome
    this.gender = data.gender || '';
    this.date_of_birth = data.date_of_birth || '';
    this.race = data.race || '';

    if (this.gender === 'n/a') {
      this.gender = 'N/A';
    }
    if (this.race === 'n/a') {
      this.race = 'N/A';
    }

    // survey
    this.student_profile = null; // filled via 2nd api call
    this.counselor_profile = null;
    this.skippedSurvey = false; // filled in if skipped survey

    // header
    this.num_pending_payments = 0;

    this.bio = data.bio || '';
    this.email = data.email || '';

    this.school = data.school || null;
  }

  get display_label() {
    if (this.email) {
      return `${this.displayName} (${this.email})`;
    }

    return this.displayName;
  }

  get userTypeDisplay() {
    if (this.is_super_admin) {
      return 'Admin';
    }

    if (this.is_college_admin) {
      return 'Admin';
    }

    if (this.is_counselor) {
      return 'Counselor';
    }

    if (this.is_student) {
      return 'User';
    }

    return '';
  }

  get isStudent() {
    return this.is_student;
  }

  get isCounselor() {
    return this.is_counselor;
  }

  get isAdmin() {
    return this.is_super_admin;
  }

  get isCollegeAdmin() {
    return this.is_college_admin;
  }

  get canAddEvents() {
    return this.isAdmin || this.isCollegeAdmin;
  }

  get canAddSessions() {
    return this.isAdmin || this.isCollegeAdmin || this.isCounselor;
  }

  // Login/Register -> Confirm -> Welcome -> Survey

  get needsWelcome() {
    if (this.isCounselor) {
      return !this.counselor_profile
        || !this.counselor_profile.completed_profile;
    }

    // if (this.is_student) {
    //   return !this.student_profile.completed_profile
    // }
    // return false;
    return !this.date_of_birth.length
  }

  get hasInitializedCal() {
    return this.counselor_profile && (this.counselor_profile.calendar_initialized || this.counselor_profile.in_app_calendar_initialized);
  }

  get needsSurvey() {
    return this.isStudent && (!this.student_profile || !this.student_profile.completed_survey);
  }

  get homeRouteName() {
    if (this.isStudent) {
      if (this.needsWelcome) {
        return 'welcome';
      }
      if (this.needsSurvey && !this.skippedSurvey) {
        return 'mental-health-survey';
      }
      return 'student-dashboard';
    }

    if (this.isCounselor) {
      if (this.needsWelcome)
        return 'counselor-welcome';
      if (!this.hasInitializedCal)
        return 'availability';
      return 'counselor-dashboard';
    }

    if (this.isCollegeAdmin) {
      return 'college-dashboard';
    }

    if (this.isAdmin) {
      return 'admin-dashboard';
    }

    return 'dashboard';
  }

  get displayName() {
    return this.first_name || (this.isStudent ? 'Student' : 'Counselor');
  }

  get fullNameShort() {
    if (this.last_name && this.last_name.length) {
      return `${this.first_name} ${this.last_name[0]}`;
    }
    return this.displayName;
  }

  get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  // welcome step 2
  get student_status() {
    return this.student_profile && this.student_profile.student_status;
  }

  get international_student() {
    return this.student_profile && this.student_profile.international_student;
  }

  get student_athlete() {
    return this.student_profile && this.student_profile.student_athlete;
  }


  storeWelcomeStepOneData(user) {
    this.date_of_birth = user.date_of_birth;
    this.gender = user.gender;
    this.race = user.race;
    this.city = user.city;
  }

  storeWelcomeStepTwoData(user) {
    if (!this.student_profile) {
      this.student_profile = new StudentProfileModel({});
    }

    this.student_profile.student_status = user.student_status;
    this.student_profile.international_student = user.international_student;
    this.student_profile.student_athlete = user.student_athlete;
  }

  storeWelcomeCounselorData(data) {
    // todo:
  }

  setFinishedCounselorOnboarding() {
    this.counselor_profile.completed_profile = true;
    this.counselor_profile.calendar_initialized = true;
  }
}
